import UISideNav from 'ui-addon-react-router-dom/UIRouterSideNav';
import { H7 } from 'UIComponents/elements/headings';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIPopover from 'UIComponents/tooltip/UIPopover';
import { RouterLink } from '../../../components/AcademyLinks';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'academy-common-lib/utils/Styling';
const POPOVER_WIDTH = 300;
const POPOVER_PADDING = 12;
export const CardMenu = styled(UIPopover).withConfig({
  displayName: "CardMenu",
  componentId: "sc-1srkz2i-0"
})(["width:", "px;.uiPopoverBody,.uiPopoverHeader,.uiPopoverFooter{padding:0;}"], POPOVER_WIDTH);
export const CardMenuHeader = styled(H7).withConfig({
  displayName: "CardMenu__CardMenuHeader",
  componentId: "sc-1srkz2i-1"
})(["padding:", "px;"], POPOVER_PADDING);
export const CardMenuFooterLink = styled(RouterLink).withConfig({
  displayName: "CardMenu__CardMenuFooterLink",
  componentId: "sc-1srkz2i-2"
})(["padding:", "px;display:block;"], POPOVER_PADDING);
export const CardMenuOptions = styled(UISideNav).withConfig({
  displayName: "CardMenu__CardMenuOptions",
  componentId: "sc-1srkz2i-3"
})(["padding:", "px 0 ", "px ", "px;"], POPOVER_PADDING, POPOVER_PADDING, POPOVER_PADDING);
export const CardMenuActionLabel = styled(FormattedMessage).withConfig({
  displayName: "CardMenu__CardMenuActionLabel",
  componentId: "sc-1srkz2i-4"
})(["flex:1;opacity:", ";"], props => props.disabled ? 0.3 : 1);
export const CardMenuAction = styled(UIFlex).withConfig({
  displayName: "CardMenu__CardMenuAction",
  componentId: "sc-1srkz2i-5"
})(["padding-right:8px;"]);
export const ReducedCardMenuIconBox = styled.div.withConfig({
  displayName: "CardMenu__ReducedCardMenuIconBox",
  componentId: "sc-1srkz2i-6"
})([".card-menu-icon{background-color:transparent;}"]);